import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  Signal,
} from '@angular/core';
import { Router } from '@angular/router';
import { HeaderComponent } from '../shared/header/header.component';
import { AlfredClientComponent } from '@lyceo/alfred-client';
import {
  IonCard,
  IonCardContent,
  IonCol,
  IonContent,
  IonGrid,
  IonRow,
  IonSkeletonText,
} from '@ionic/angular/standalone';
import { SessionFacade } from '../+state/session/session.facade';
import { Session } from '../+state/session/session.model';

@Component({
  selector: 'app-direct-link-page',
  templateUrl: './direct-link-page.component.html',
  styleUrls: ['./direct-link-page.component.scss'],
  imports: [
    HeaderComponent,
    AlfredClientComponent,
    IonContent,
    IonCard,
    IonCardContent,
    IonGrid,
    IonRow,
    IonCol,
    IonSkeletonText,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DirectLinkPageComponent implements OnInit {
  private readonly router: Router = inject(Router);
  private readonly sessionFacade: SessionFacade = inject(SessionFacade);

  protected readonly selectedSession: Signal<Session | undefined> =
    this.sessionFacade.selectedSession;
  protected readonly sessionLoading: Signal<boolean> =
    this.sessionFacade.sessionLoading;

  public ngOnInit(): void {
    this.sessionFacade.loadSession();
  }

  protected navigateToHome(): void {
    this.router.navigate(['/home']);
  }
}
